import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      age: 45,
      treatment: 'Estrogen & Progesterone Therapy',
      quote: 'After struggling with menopause symptoms for years, hormone optimization has given me my life back. My energy is through the roof, I\'m sleeping better, and I feel like myself again.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/26092ed2fd9f4e118cfed8cdb9154f64.jpg'
    },
    {
      name: 'Michael Rodriguez',
      age: 52,
      treatment: 'Testosterone Optimization',
      quote: 'The difference in my energy, strength, and overall vitality has been incredible. I feel 10 years younger and my workouts are more effective than they\'ve been in decades.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20confident%20middle-aged%20man%2C%20business%20casual%20attire%2C%20genuine%20smile%2C%20clean%20white%20background%2C%20professional%20lighting%2C%20healthcare%20testimonial%20style%2C%20energetic%20and%20healthy%20appearance&width=300&height=300&seq=testimonial-michael&orientation=squarish'
    },
    {
      name: 'Jennifer Chen',
      age: 38,
      treatment: 'Thyroid & Hormone Optimization',
      quote: 'I was constantly exhausted and gaining weight despite eating well and exercising. Hormone therapy addressed the root cause and I finally have my metabolism back on track.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20confident%20Asian%20woman%2C%20professional%20attire%2C%20bright%20smile%2C%20clean%20white%20background%2C%20professional%20lighting%2C%20healthcare%20testimonial%20style%2C%20vibrant%20and%20healthy%20appearance&width=300&height=300&seq=testimonial-jennifer&orientation=squarish'
    },
    {
      name: 'David Thompson',
      age: 48,
      treatment: 'Comprehensive Hormone Panel',
      quote: 'The comprehensive approach and ongoing monitoring gave me confidence in the treatment. The results speak for themselves - better sleep, mood, and physical performance.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20confident%20middle-aged%20man%2C%20business%20attire%2C%20warm%20smile%2C%20clean%20white%20background%2C%20professional%20lighting%2C%20healthcare%20testimonial%20style%2C%20satisfied%20and%20healthy%20appearance&width=300&height=300&seq=testimonial-david&orientation=squarish'
    }
  ];

  const stats = [
    {
      number: '95%',
      label: 'Patient Satisfaction Rate',
      icon: 'ri-heart-3-line'
    },
    {
      number: '2-4 weeks',
      label: 'Average Time to Feel Results',
      icon: 'ri-time-line'
    },
    {
      number: '500+',
      label: 'Successful Treatments',
      icon: 'ri-user-heart-line'
    },
    {
      number: '10+ years',
      label: 'Clinical Experience',
      icon: 'ri-award-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Real Results from <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Real Patients</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how hormone optimization has transformed the lives of our patients, 
            helping them reclaim their vitality and well-being.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-bold text-gray-900">{testimonial.name}</h3>
                  <p className="text-gray-600">Age {testimonial.age} • {testimonial.treatment}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <blockquote className="text-gray-700 italic leading-relaxed">
                "{testimonial.quote}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl p-8 lg:p-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Proven Track Record of Success
          </h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-gray-600 mb-6">
              Take the first step toward optimal health and vitality with personalized hormone optimization.
            </p>
            <button className="bg-gradient-to-r from-pink-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:from-pink-700 hover:to-purple-700 transition-all duration-300">
              <i className="ri-user-add-line mr-2"></i>
              Start Your Journey Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;